import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failurelistVideoTutorialCategory,
    successlistVideoTutorialCategory,
} from "./ListVideoTutorialCategorySlice";
import { failureaddVideoTutorialCategory, successaddVideoTutorialCategory } from "./AddVideoTutorialCategorySlice";
import { failureeditVideoTutorialCategory, successeditVideoTutorialCategory } from "./EditVideoTutorialCategorySlice";
import { failuredeleteVideoTutorialCategory, successdeleteVideoTutorialCategory } from "./DeleteVideoTutorialCategorySlice";
import { IVideoTutorialCategory } from "../../../Pages/VideoTutorialCategory/IVideoTutorialCategory";

const ListVideoTutorialCategoryApi = (action: PayloadAction<any>) => {
    return api.get("/api/videoTutorials/category/", {
        params: action.payload,
    });
};

export function* ListVideoTutorialCategoryCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(ListVideoTutorialCategoryApi, action);
        yield put(successlistVideoTutorialCategory(response.data));
    } catch (error) {
        yield put(failurelistVideoTutorialCategory(error));
    }
}

// add
const AddVideoTutorialCategoryApi = (action: PayloadAction<IVideoTutorialCategory>) => {
    return api.post("/api/videoTutorials/category/", action.payload);
};

export function* AddVideoTutorialCategoryCall(action: PayloadAction<IVideoTutorialCategory>) {
    try {
        const response: AxiosResponse = yield call(AddVideoTutorialCategoryApi, action);
        yield put(successaddVideoTutorialCategory(response.data));
    } catch (error) {
        yield put(failureaddVideoTutorialCategory(error));
    }
}

// edit
const EditVideoTutorialCategoryApi = (action: PayloadAction<IVideoTutorialCategory>) => {
    return api.post("/api/videoTutorials/category/", action.payload);
};

export function* EditVideoTutorialCategoryCall(action: PayloadAction<IVideoTutorialCategory>) {
    try {
        const response: AxiosResponse = yield call(EditVideoTutorialCategoryApi, action);
        yield put(successeditVideoTutorialCategory(response.data));
    } catch (error) {
        yield put(failureeditVideoTutorialCategory(error));
    }
}

// delete
const DeleteVideoTutorialCategoryApi = (action: PayloadAction<any>) => {
    return api.post("/api/videoTutorials/category/", action.payload);
};

export function* DeleteVideoTutorialCategoryCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(DeleteVideoTutorialCategoryApi, action);
        yield put(successdeleteVideoTutorialCategory(response.data));
    } catch (error) {
        yield put(failuredeleteVideoTutorialCategory(error));
    }
}
